import { Component, OnInit, Input } from '@angular/core';
import { Task } from '../../../core/models/index';

@Component({
  selector: 'app-assistance-view',
  templateUrl: './assistance-view.component.html',
  styleUrls: ['./assistance-view.component.scss']
})
export class AssistanceViewComponent implements OnInit {

  @Input() task? : Task
  @Input() assistanceId : string

  constructor() {}

  ngOnInit(): void {
  }

}
